
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projekte/[id]",
      function () {
        return require("private-next-pages/projekte/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projekte/[id]"])
      });
    }
  